module.exports = __webpack_public_path__ + "static/img/12.a790a407.jpg";